import React, { useState } from "react";
import PayloftLogo from "../assets/images/payloft-logo.png";
import toast from "react-hot-toast";
import { resetPasswordRequest } from "../services/onboarding";
import { ReactComponent as Spinner } from "../assets/icons/spinner.svg";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState("");

  const handleResetRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await resetPasswordRequest(email);
      toast.success(response.message);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        setLoading(false);
      }
    }
  };

  return (
    <div className="flex justify-center">
      <div className="md:w-[448px] max-w-96 p-4">
        <div className="flex items-center justify-center">
          <img
            src={window.__TENANT__?.logo ?? PayloftLogo}
            alt="logo"
            className="w-[92px] h-auto"
          />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-20 text-center mt-20">
          Reset Password
        </h1>
        <div className="mt-4">
          <form onSubmit={handleResetRequest}>
            <div className="flex flex-col">
              <label htmlFor="email">Email Address</label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="example@gmail.com"
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
              />
            </div>
            <div className="md:mt-20 mt-5 text-center">
              <button
                type="submit"
                className="bg-primary text-white w-[21rem] md:w-[348px] h-[50px] rounded-md"
              >
                {loading ? (
                  <div className="spinner">
                    <Spinner />
                  </div>
                ) : (
                  "Reset Password"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
